import CrudRepository from './CrudRepository'
import Repository from './Repository'
import Store from '../store/index'

export default class ServicesRepository extends CrudRepository {
  constructor () {
    super('core/api/services/web')
  }

  async getPage (page, size) {
    // const token = localStorage.getItem('token')
    // const requested = { Authorization: 'Bearer ' + token }
    const formData = new FormData()
    formData.append('gsm', Store.state.selectedNumber)
    const data = await Repository.post(`${this.resource}`, formData, { params: { page: page, size: size } })
    return data.data
  }
}
